<template>
  <v-card>
    <v-card-title class="pb-0">
      <h1 class="headline">
        Описание товаров(черновики)
      </h1>
      <v-btn
        color="primary"
        small
        class="my-0"
        :loading="draftLoading"
        :disabled="!drafts.length"
        @click="importDrafts"
      >
        Загрузить
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table
        v-if="drafts.length>0"
        :items="drafts"
        :headers="headers"
        hide-actions
        :pagination.sync="pagination"
        :rows-per-page-items="[14]"
        class="elevation-1 mb-1 table-striped"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <tr>
            <td :class="{'red lighten-4': (props.item.Manufacturer === '')}">
              <v-tooltip
                v-if="(props.item.Manufacturer === '')"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <CellEditor
                      :id="props.item.Id"
                      v-model="props.item.Manufacturer"
                      :label="{name: 'Manufacturer', text: 'Производитель'}"
                      @change="updateGoodsItem"
                    />
                  </span>
                </template>
                <span>Поле обязательно для заполнения</span>
              </v-tooltip>
              <CellEditor
                v-else
                :id="props.item.Id"
                v-model="props.item.Manufacturer"
                :label="{name: 'Manufacturer', text: 'Производитель'}"
                @change="updateGoodsItem"
              />
            </td>
            <td :class="{'red lighten-4': (props.item.Trademark === '')}">
              <CellEditor
                :id="props.item.Id"
                v-model="props.item.Trademark"
                :label="{name: 'Trademark', text: 'ТМ'}"
                @change="updateGoodsItem"
              />
            </td>
            <td :class="{'red lighten-4': (props.item.TrademarkModel === '' && props.item.Article === '')}">
              <v-tooltip
                v-if="(props.item.TrademarkModel === '' && props.item.Article === '')"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <CellEditor
                      :id="props.item.Id"
                      v-model="props.item.TrademarkModel"
                      :label="{name: 'TrademarkModel', text: 'Модель'}"
                      @change="updateGoodsItem"
                    />
                  </span>
                </template>
                <span>Обязательно минимум одно из полей: Модель или Артикул</span>
              </v-tooltip>
              <CellEditor
                v-else
                :id="props.item.Id"
                v-model="props.item.TrademarkModel"
                :label="{name: 'TrademarkModel', text: 'Модель'}"
                @change="updateGoodsItem"
              />
            </td>
            <td :class="{'red lighten-4': (props.item.TrademarkModel === '' && props.item.Article === '')}">
              <v-tooltip
                v-if="(props.item.TrademarkModel === '' && props.item.Article === '')"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <CellEditor
                      :id="props.item.Id"
                      v-model="props.item.Article"
                      :label="{name: 'Article', text: 'Артикул'}"
                      @change="updateGoodsItem"
                    />
                  </span>
                </template>
                <span>Обязательно минимум одно из полей: Модель или Артикул</span>
              </v-tooltip>
              <CellEditor
                v-else
                :id="props.item.Id"
                v-model="props.item.Article"
                :label="{name: 'Article', text: 'Артикул'}"
                @change="updateGoodsItem"
              />
            </td>
            <td :class="{'red lighten-4': (props.item.Nomenclature === '')}">
              <v-tooltip
                v-if="(props.item.Nomenclature === '')"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <CellEditor
                      :id="props.item.Id"
                      v-model="props.item.Nomenclature"
                      :label="{name: 'Nomenclature', text: 'Номенклатура'}"
                      @change="updateGoodsItem"
                    />
                  </span>
                </template>
                <span>Поле обязательно для заполнения</span>
              </v-tooltip>
              <CellEditor
                v-else
                :id="props.item.Id"
                v-model="props.item.Nomenclature"
                :label="{name: 'Nomenclature', text: 'Номенклатура'}"
                @change="updateGoodsItem"
              />
            </td>
            <td :class="{'red lighten-4': (props.item.Material === '')}">
              <v-tooltip
                v-if="(props.item.Material === '')"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <CellEditor
                      :id="props.item.Id"
                      v-model="props.item.Material"
                      :label="{name: 'Material', text: 'Материал'}"
                      @change="updateGoodsItem"
                    />
                  </span>
                </template>
                <span>Поле обязательно для заполнения</span>
              </v-tooltip>
              <CellEditor
                v-else
                :id="props.item.Id"
                v-model="props.item.Material"
                :label="{name: 'Material', text: 'Материал'}"
                @change="updateGoodsItem"
              />
            </td>
            <td :class="{'red lighten-4': (props.item.Country === '' || !props.item.IsCountryEntity )}">
              <v-tooltip
                v-if="(props.item.Country === '' || !props.item.IsCountryEntity)"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <CellEditor
                      :id="props.item.Id"
                      v-model="props.item.Country"
                      :label="{name: 'Country', text: 'Страна происхождения'}"
                      @change="updateGoodsItem"
                    />
                  </span>
                </template>
                <span>{{ (props.item.Country === '') ? 'Поле обязательно для заполнения' : 'Такая страна отсутствует в справочнике' }}</span>
              </v-tooltip>
              <CellEditor
                v-else
                :id="props.item.Id"
                v-model="props.item.Country"
                :label="{name: 'Country', text: 'Страна происхождения'}"
                @change="updateGoodsItem"
              />
            </td>
            <td :class="{'red lighten-4': (props.item.Unit === '')}">
              <v-tooltip
                v-if="(props.item.Unit === '')"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <CellEditor
                      :id="props.item.Id"
                      v-model="props.item.Unit"
                      :label="{name: 'Unit', text: 'Ед.изм.'}"
                      @change="updateGoodsItem"
                    />
                  </span>
                </template>
                <span>Поле обязательно для заполнения</span>
              </v-tooltip>
              <CellEditor
                v-else
                :id="props.item.Id"
                v-model="props.item.Unit"
                :label="{name: 'Unit', text: 'Ед.изм.'}"
                @change="updateGoodsItem"
              />
            </td>
            <td>
              <CellEditor
                :id="props.item.Id"
                v-model="props.item.Dimensions"
                :label="{name: 'Dimensions', text: 'Габаритный размер'}"
                @change="updateGoodsItem"
              />
            </td>
            <td>
              <CellEditor
                :id="props.item.Id"
                v-model="props.item.WeightNetto"
                :label="{name: 'WeightNetto', text: 'Вес нетто'}"
                @change="updateGoodsItem"
              />
            </td>
            <td>
              <CellEditor
                :id="props.item.Id"
                v-model="props.item.WeightBrutto"
                :label="{name: 'WeightBrutto', text: 'Вес брутто'}"
                @change="updateGoodsItem"
              />
            </td>
            <td>
              <CellEditor
                :id="props.item.Id"
                v-model="props.item.Site"
                :label="{name: 'Site', text: 'Сайт товара'}"
                @change="updateGoodsItem"
              />
            </td>
            <td>
              <v-btn
                small
                icon
                @click="deleteDraft(props.item.Id)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-model="pagination.page"
          :length="pages"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import CellEditor from "./CellEditor.vue";
import * as importApi from "../../../backend/importApi.js";

export default {
  components: {
    CellEditor,
  },
  data() {
    return {
      drafts: [],
      headers: [
        {
          text: "Производитель",
          sortable: false,
        },
        { text: "ТМ", sortable: false },
        {
          text: "Модель",
          sortable: false,
        },
        { text: "Артикул", sortable: false },
        {
          text: "Номенклатура",
          sortable: false,
        },
        { text: "Материал", sortable: false },
        {
          text: "Страна происхождения",
          sortable: false,
        },
        {
          text: "Ед.изм.",
          sortable: false,
        },
        {
          text: "Габаритный размер",
          sortable: false,
        },
        {
          text: "Вес нетто",
          name: "WeightNetto",
          tooltip: "",
          sortable: false,
        },
        {
          text: "Вес брутто",
          sortable: false,
        },
        { text: "Сайт товара", sortable: false },
        { text: "", sortable: false },
      ],
      pagination: {},
      draftLoading: false,
    };
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage,
      );
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.drafts = await importApi.getAllImportDrafts();
    },
    async importDrafts() {
      this.draftLoading = true;
      await importApi.importDrafts(this.drafts);
      this.showInfo("Описание товаров импортированы в справочник");
      this.getData();
      this.draftLoading = false;
    },
    async deleteDraft(id) {
      await importApi.deleteDraft(id);
      this.getData();
    },
    async updateGoodsItem(value) {
      const item = this.drafts.find((i) => i.Id === value.id);
      for (const key in item) {
        if (key === value.label) {
          item[key] = value.newValue;
        }
      }
      await importApi.updateGoodsItem(value.id, item);
      this.getData();
    },
  },
};
</script>
